import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CompletionVideo from '../../../../../assets/img/screens/Completion.mp4'
interface WrongAnswer {
  questionIndex: number;
  scenario: string;
  userChoice: string;
  correctAnswer: string;
  feedback: string;
  skill: string;
}

interface CompletionScreenProps {
  totalQuestions: number;
  correctCount: number;
  wrongAnswers: WrongAnswer[];
  onRetry: () => void;
  playTone: (kind: string) => void;
  passPercentage: number;
  hasPreviouslyPassed: boolean;
   setCurrentScreenId:any;
   reportFetchData:any;
      milestoneQuest:any;
     setMilestoneQuest:any;
     showCompletionVideo:any;
     setShowCompletionVideo:any;
}

const SKILL_DISPLAY: Record<string, string> = {
  "Goal Setting": "Goal Setting",
  "Giving Feedback": "Giving Feedback",
  Delegation: "Delegation",
  "Conflict Management": "Conflict Management",
};

const SKILLS = ["Goal Setting", "Delegation", "Giving Feedback", "Conflict Management"];

type View = "summary" | "drilldown";
const milestoneContent: Record<string, { title: string; description: string }> = {
  '1': {
    title: 'Milestone Unlocked',
    description:
      "Activation complete. You’ve helped make ECHO a reality. ECHO is now fully online as your AI teammate!",
  },
  
};

const MilestoneOverlay = ({
  questId,
  onContinue,
}: {
  questId: string;
  onContinue: () => void;
}) => {
  const content = milestoneContent[questId];
  if (!content) return null;

  return (
    <div
  className="milestone-overlay active"
  style={{
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99998,
    backdropFilter: "blur(4px)",
  }}
>
     <div
  className="milestone-card"
  style={{
    maxWidth: "420px",
    width: "90%",
    padding: "28px",
    borderRadius: "16px",
    background: "linear-gradient(180deg, #03151f, #042636)",
    boxShadow: "0 0 40px rgba(0,255,255,0.4)",
    textAlign: "center",
  }}
>

        <div className="milestone-scanlines" />

        <div className="milestone-icon">
          <svg viewBox="0 0 64 64">
            <circle cx="32" cy="32" r="28" strokeDasharray="4 4" />
            <path d="M32 12 L32 24 M32 40 L32 52 M12 32 L24 32 M40 32 L52 32" />
            <circle cx="32" cy="32" r="8" />
            <polygon points="32,20 35,28 32,26 29,28" fill="var(--cyan)" />
            <polygon points="32,44 35,36 32,38 29,36" fill="var(--cyan)" />
          </svg>
        </div>

        <h2 className="milestone-title">{content.title}</h2>
        <p className="milestone-description">{content.description}</p>

        <button className="milestone-btn" onClick={onContinue}>
          Continue
        </button>

      </div>
    </div>
  );
};
export default function CompletionScreen({
  totalQuestions,
  correctCount,
  wrongAnswers,
  onRetry,
  playTone,
  passPercentage,
    hasPreviouslyPassed,
     setCurrentScreenId,
     reportFetchData,
     milestoneQuest,
     setMilestoneQuest,
     showCompletionVideo,
     setShowCompletionVideo
}: CompletionScreenProps) {
  const confettiRef = useRef<HTMLCanvasElement>(null);
  const navigate = useNavigate();
  const percentage = Math.round((correctCount / totalQuestions) * 100);
  // const passed = percentage >= passPercentage;


  //new
  const currentPassed = percentage >= passPercentage;
// If passed now OR passed before
const passed = currentPassed || hasPreviouslyPassed;

  const needed = Math.max(0, Math.ceil(totalQuestions * (passPercentage / 100)) - correctCount);

  const [view, setView] = useState<View>("summary");
  const [activeSkill, setActiveSkill] = useState<string>("");
  const [drillIndex, setDrillIndex] = useState(0);
  const [reviewedSkills, setReviewedSkills] = useState<Set<string>>(new Set());

  const wrongBySkill = (skill: string) => wrongAnswers.filter((w) => w.skill === skill);

  useEffect(() => {
    if (passed) launchConfetti();
    // Play with minimal delay to stay within user gesture window
    const t = setTimeout(() => {
      try {
        playTone("complete");
      } catch {}
    }, 100);
    return () => clearTimeout(t);
  }, []);

  function launchConfetti() {
    playTone("fanfare");
    const canvas = confettiRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d")!;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const particles: any[] = [];
    const colors = ["rgba(54,231,255,0.9)", "rgba(180,107,255,0.9)", "rgba(255,255,255,0.8)", "rgba(100,255,218,0.9)"];
    const cx = canvas.width / 2,
      cy = canvas.height / 2;

    for (let i = 0; i < 120; i++) {
      const angle = (Math.PI * 2 * i) / 120 + Math.random() * 0.5;
      const speed = Math.random() * 8 + 4;
      particles.push({
        x: cx,
        y: cy,
        size: Math.random() * 6 + 3,
        color: colors[Math.floor(Math.random() * colors.length)],
        speedX: Math.cos(angle) * speed,
        speedY: Math.sin(angle) * speed,
        rotation: Math.random() * 360,
        rotationSpeed: Math.random() * 15 - 7.5,
        alpha: 1,
        decay: Math.random() * 0.015 + 0.008,
      });
    }

    function animate() {
      ctx.clearRect(0, 0, canvas!.width, canvas!.height);
      particles.forEach((p) => {
        p.x += p.speedX;
        p.y += p.speedY;
        p.speedY += 0.15;
        p.speedX *= 0.98;
        p.alpha -= p.decay;
        p.rotation += p.rotationSpeed;
        if (p.alpha <= 0) return;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rotation * Math.PI) / 180);
        ctx.globalAlpha = Math.max(0, p.alpha);
        ctx.fillStyle = p.color;
        ctx.beginPath();
        for (let j = 0; j < 6; j++) {
          const a = (Math.PI / 3) * j;
          const px = Math.cos(a) * p.size;
          const py = Math.sin(a) * p.size;
          j === 0 ? ctx.moveTo(px, py) : ctx.lineTo(px, py);
        }
        ctx.closePath();
        ctx.fill();
        ctx.restore();
      });
      if (particles.some((p) => p.alpha > 0)) requestAnimationFrame(animate);
    }
    animate();
  }
const handleMilestoneContinue = () => {
  setMilestoneQuest(null);

  // Go to next screen
  setCurrentScreenId(21);
};
  const openSkill = (skill: string) => {
    const items = wrongBySkill(skill);
    if (items.length === 0) return;
    playTone("tap");
    setActiveSkill(skill);
    setDrillIndex(0);
    setReviewedSkills((prev) => new Set(prev).add(skill));
    setView("drilldown");
  };

  const backToOverview = () => {
    playTone("success");
    setView("summary");
  };


  if (view === "drilldown") {
    const items = wrongBySkill(activeSkill);
    const item = items[drillIndex];
   
    return (
      <div
        className="assess-completion-enter"
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "16px",
          flex: 1,
          justifyContent: "center",
          overflow: "auto",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
          <button className="assess-primary-btn" onClick={backToOverview} style={{ padding: "6px 14px", fontSize: 12 }}>
            ← Back
          </button>
          <span style={{ fontSize: 14, fontWeight: 700, color: "var(--assess-cyan)" }}>
            {SKILL_DISPLAY[activeSkill] || activeSkill}
          </span>
          <span style={{ fontSize: 12, color: "var(--assess-muted)", marginLeft: 6 }}>
            {drillIndex + 1}/{items.length}
          </span>
        </div>

        {item && (
          <div className="assess-drilldown-card">
            <div style={{ fontSize: 12, color: "var(--assess-muted)", marginBottom: 6 }}>
              Question {item.questionIndex + 1}
            </div>
            <div style={{ fontSize: 14, color: "rgba(255,255,255,0.9)", lineHeight: 1.45, marginBottom: 14 }}>
              {item.scenario}
            </div>

            <div className="assess-drilldown-divider" />

            <div className="assess-drilldown-label">Your answer</div>
            <div className="assess-drilldown-answer neutral">
              <div>{item.userChoice}</div>
            </div>

            <div className="assess-drilldown-divider" />

            <div style={{ fontSize: 13, marginTop: 4 }}>
              <span style={{ fontWeight: 600, color: "var(--assess-cyan)" }}>What didn't land: </span>
              <span style={{ color: "rgba(255,255,255,0.75)", fontStyle: "italic" }}>{item.feedback}</span>
            </div>
          </div>
        )}

        <div style={{ display: "flex", gap: 10, marginTop: 14, justifyContent: "center" }}>
          {drillIndex > 0 && (
            <button
              className="assess-primary-btn"
              onClick={() => {
                playTone("tap");
                setDrillIndex((i) => i - 1);
              }}
              style={{ padding: "8px 18px", fontSize: 13 }}
            >
              ← Back
            </button>
          )}
          <button
            className="assess-primary-btn"
            onClick={() => {
              playTone("tap");
              if (drillIndex >= items.length - 1) {
                backToOverview();
              } else {
                setDrillIndex((i) => i + 1);
              }
            }}
            style={{ padding: "8px 18px", fontSize: 13 }}
          >
            {drillIndex >= items.length - 1 ? "Complete" : "Next →"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      {passed && <canvas ref={confettiRef} id="assess-confetti-canvas" />}
      <div
        className="assess-chat assess-completion-enter"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "12px 14px",
          flex: 1,
          overflow: "visible",
        }}
      >
        <div style={{ fontSize: 36, marginBottom: 6 }}>{passed ? "🎉" : "🧭"}</div>
        <h1
          style={{
            fontSize: 22,
            fontWeight: 800,
            margin: "0 0 2px",
            color: "#fff",
            textShadow: passed ? "0 0 30px rgba(54,231,255,.4)" : "none",
          }}
        >
          {passed ? "You are Certified!" : "Almost there!"}
        </h1>
        <p style={{ fontSize: 13, color: "rgba(255,255,255,.7)", margin: "0 0 4px" }}>
          {passed
            ? "Congratulations! You've completed the assessment successfully."
            : "Good effort. Let's sharpen a few areas."}
        </p>

        <div className="assess-score-display" style={{ margin: "2px 0 6px" }}>
          {percentage}%
        </div>

        <p style={{ fontSize: 13, color: "rgba(255,255,255,.85)", margin: "0 0 8px", maxWidth: 460, lineHeight: 1.4 }}>
          {passed
            ? correctCount === totalQuestions
              ? "Perfect score. Strong judgement across scenarios."
              : "You passed. Click each skill below to review your focus areas and ace the assessment."
            : `You need ${needed} more correct to reach ${passPercentage}%. Click each skill below to review your focus areas, then retry.`}
        </p>

        <div className="assess-skill-grid">
          {SKILLS.map((skill) => {
            const count = wrongBySkill(skill).length;
            const allCorrect = count === 0;
            return (
              <button
                key={skill}
                className={`assess-skill-bucket${allCorrect ? " assess-skill-clear" : ""}${reviewedSkills.has(skill) ? " assess-skill-reviewed" : ""}`}
                onClick={() => openSkill(skill)}
                disabled={allCorrect}
              >
                <div className="assess-skill-name">{SKILL_DISPLAY[skill] || skill}</div>
                <div className="assess-skill-count">{allCorrect ? "✓ All correct" : `${count} to revisit`}</div>
              </button>
            );
          })}
        </div>

        <div
          style={{
            display: "flex",
            gap: 10,
            marginTop: 12,
            width: "100%",
            maxWidth: 520,
            justifyContent: passed ? "space-between" : "center",
          }}
        >
          <button
            className="assess-primary-btn"
            onClick={() => {
              playTone("tap");
              onRetry();
            }}
          >
            🔄 Retry Assessment
          </button>

          {passed && (
            <button
              className="assess-primary-btn"

onClick={() => {
  playTone("tap");
  reportFetchData();

  // Show completion video first
  setShowCompletionVideo(true);
}}
              style={{
                background: "linear-gradient(135deg, rgba(255,215,0,0.25), rgba(255,165,0,0.2))",
                borderColor: "rgba(255,215,0,0.5)",
              }}
            >
              Continue →
            </button>
          )}

         
        </div>
      </div>
       {milestoneQuest && (
  <MilestoneOverlay
    questId={milestoneQuest}
    onContinue={handleMilestoneContinue}
  />
)}
    </>
  );
}
